export default __webpack_public_path__ + "static/media/screenBlock24.95aa9867.jpg";